<span class="label">{{ label }}</span>
<div
  class="switch"
  [ngClass]="{ 'switch--active': _value, 'switch--disabled': _disabled, 'switch--no-transition': !_transitionEnabled }"
  (click)="!_disabled && onChange()"
></div>
